require("./axios");

//inicia o AOS
AOS.init();
